export default {
  VERSIONHISTORY_LIST (state, value) {
    state.list = (value && Array.isArray(value)) ? [...value] : []
  }
}
